import { Col, Container, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { AboutUsJumboIcon } from "../../assets/icons/aboutus-icon";
import { motion } from "framer-motion";
import "./AboutUsJumbotron.scss";

const AboutUsJumbotron = () => {
  const { t } = useTranslation(["translation", "de"]);
  return (
    <Container fluid className="about-us-jumbotron">
      {/* Decorative elements */}
      <div className="about-jumbotron-deco">
        <svg className="deco-ring" viewBox="0 0 200 200" fill="none">
          <circle cx="100" cy="100" r="98" stroke="#B8860B" strokeWidth="0.5" opacity="0.1"/>
          <circle cx="100" cy="100" r="60" stroke="#B8860B" strokeWidth="0.3" opacity="0.06"/>
        </svg>
      </div>
      <Row className="about-us-jumbotron__row flex-column flex-sm-row">
        <Col className="about-us-jumbotron__row__col">
          <motion.div
            className="about-badge"
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5 }}
          >
            <svg width="14" height="14" viewBox="0 0 16 16" fill="none">
              <path d="M8 0L10.12 5.88L16 8L10.12 10.12L8 16L5.88 10.12L0 8L5.88 5.88L8 0Z" fill="#B8860B"/>
            </svg>
            <span>About Us</span>
          </motion.div>
          <motion.h1
            className="about-us-jumbotron__row__col__title"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            {t('booking.title')}
          </motion.h1>
          <motion.div
            className="about-gold-line"
            initial={{ width: 0 }}
            animate={{ width: 60 }}
            transition={{ duration: 0.6, delay: 0.3 }}
          />
          <motion.p
            className="about-us-jumbotron__row__col__subtitle"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            {t('booking.subtitle')}
          </motion.p>
        </Col>
        <Col className="about-us-jumbotron__row__icon">
          <motion.div
            initial={{ opacity: 0, scale: 0.85 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 1, delay: 0.3 }}
          >
            <AboutUsJumboIcon />
          </motion.div>
        </Col>
      </Row>
    </Container>
  );
};

export default AboutUsJumbotron;
